import { useEffect, useState } from 'react'
import "./Conditions.css"
import Side from '../sidecontainer/side'
import { getGCU } from '../../HTTP/user'
const Conditions = () => {

  const [gcu, setGcu] = useState(null); // string html

  useEffect(() => {
    const fetchGCU = async () => {
      try {
        const res = await getGCU();
        if (res) {
          setGcu(res.value);
        }
      }  catch (error) {
        console.error("Erreur lors de la récupération des CGU :", error);
      }
    }
    fetchGCU();
  }, []);

  return (
    <div className='mt-8 py-12 px-4 sm:px-6 lg:px-8 md:max-h-screen md:overflow-y-auto'>
      <div dangerouslySetInnerHTML={{ __html: gcu }}></div>
    </div>
  )
    
}

export default Conditions